import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TCFile } from '../../files/TCFile';
import { ButtonType } from '../buttons/button';

@Component({
    selector: 'file-explorer-summary',
    templateUrl: './file-explorer-summary.component.html'
})
export class FileExplorerSummaryComponent {
    @Input() selectedFiles: TCFile[] = [];
    @Input() height = '200px';

    @Output() removeFile = new EventEmitter<TCFile>();

    ButtonType = ButtonType;

    deselectFile(file: TCFile): void {
        this.removeFile.emit(file);
    }
}
